module.exports = fox._r("images/logo-simple-white.png", __webpack_public_path__ + "_/common/images/logo-simple-white.png");


//////////////////
// WEBPACK FOOTER
// ../common/images/logo-simple-white.png
// module id = 8
// module chunks = 2